import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { PageHeader } from "@/components/common";
import { SecuritySettings } from "@/components/settings/SecuritySettings";
import { MailboxSettings } from "@/components/settings/MailboxSettings";
import { AISettings } from "@/components/settings/AISettings";
import { CoreSettings } from "@/components/settings/CoreSettings";
import { TeamSettings, RolesMatrix } from "@/components/settings/TeamSettings";
import { ComplianceSettings, AuditLog, ReportsView, OrgSettings } from "@/components/settings/ComplianceSettings";

export default function SettingsPage() {
  const { me, can } = useAuth();
  const org = !!me?.org;
  const items = [
    { to: "security", label: "Security & profile", show: true },
    { to: "mailbox", label: "Mailbox & calendar", show: org },
    { to: "ai", label: "AI providers & budgets", show: org },
    { to: "core", label: "Core integration", show: org },
    { to: "team", label: "Team", show: org && can("org.team.manage") },
    { to: "roles", label: "Roles & permissions", show: org },
    { to: "compliance", label: "Compliance & GDPR", show: org },
    { to: "reports", label: "Reports", show: org },
    { to: "audit", label: "Audit log", show: org && can("org.audit.view") },
    { to: "organisation", label: "Organisation", show: org && can("org.settings.manage") },
  ].filter((i) => i.show);

  return (
    <div className="page">
      <PageHeader title="Settings" subtitle="Security, AI configuration, Core integration, team and compliance." />
      <div className="grid lg:grid-cols-[220px_1fr] gap-6">
        <nav className="panel p-1 h-fit" data-testid="settings-nav">
          {items.map((i) => <NavLink key={i.to} to={`/settings/${i.to}`} data-testid={`settings-nav-${i.to}`} className={({ isActive }) => `block rounded-md px-3 py-2 text-sm ${isActive ? "bg-accent text-accent-foreground font-medium" : "hover:bg-muted"}`}>{i.label}</NavLink>)}
        </nav>
        <div className="min-w-0">
          <Routes>
            <Route index element={<Navigate to="security" replace />} />
            <Route path="security" element={<SecuritySettings />} />
            {org && <Route path="mailbox" element={<MailboxSettings />} />}
            {org && <Route path="ai" element={<AISettings />} />}
            {org && <Route path="core" element={<CoreSettings />} />}
            {org && can("org.team.manage") && <Route path="team" element={<TeamSettings />} />}
            {org && <Route path="roles" element={<RolesMatrix />} />}
            {org && <Route path="compliance" element={<ComplianceSettings />} />}
            {org && <Route path="reports" element={<ReportsView />} />}
            {org && can("org.audit.view") && <Route path="audit" element={<AuditLog />} />}
            {org && can("org.settings.manage") && <Route path="organisation" element={<OrgSettings />} />}
            <Route path="*" element={<Navigate to="security" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
